<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card>
        <v-toolbar elevation="0">
          <v-toolbar-title class="pl-3 text--subtitle">
            <v-icon color="primary" style="padding-bottom: 2px">mdi-xml</v-icon>
            {{
              isNew ? 'Botão publicado com sucesso!' : 'Informações do botão'
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="px-7 py-0">
          <v-select-legacy
            v-model="buttonTarget"
            :items="targetItems"
            :label="$t('message.pages.videoPlayerButtons.buttonTarget')"
            item-value="val"
            item-text="label"
            hide-details
            class="mb-3"
          >
          </v-select-legacy>
          <v-row no-gutters>
            <v-col cols="12">
              <v-textarea-legacy
                v-model="outsideBtnCode"
                outlined
                class="wrapText mt-4 embed-textarea"
                hide-details
                dense
                no-resize
                label="Código do Botão"
                color="primary"
                readonly
                @focus="$event.target.select()"
              >
                <template v-slot:append>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click="handleShowLink(outsideBtnCode)"
                        class="mr-2"
                      >
                        mdi-content-copy
                      </v-icon>
                    </template>
                    <span>
                      {{
                        isCopied
                          ? $t('message.pages.videoEditModal.copied')
                          : $t('message.pages.videoEditModal.copyToClipboard')
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-textarea-legacy>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-8 pb-6">
          <v-spacer></v-spacer>
          <v-btn text class="mr-4 px-4" @click="handleClose">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { ENV_CONFIG } from '@/config/envs'
import i18n from '@/translations/lang.js'

export default {
  name: 'CtaModal',
  components: {},
  data: () => ({
    buttonTarget: 'standard',
    targetItems: [
      {
        val: 'standard',
        label: i18n.t('message.pages.videoPlayerButtons.targets.standard'),
      },
      {
        val: 'hls',
        label: i18n.t('message.pages.videoPlayerButtons.targets.hls'),
      },
    ],
    open: false,
    isFetching: false,
    isNew: false,
    isCopied: false,
    cta: {},
    outsideBtnCode: '',
    hlsCode: '',
    video: {},
  }),
  watch: {
    buttonTarget(val) {
      this.setOutsideBtnCode(val)
    },
  },
  computed: {
    scriptUrl() {
      return ENV_CONFIG === 'production'
        ? 'https://player.pandavideo.com.br/api.v2.js'
        : 'https://player-staging.pandavideo.com.br/api.v2.js'
    },
    isExternalSourceVideo() {
      return this.video.hasOwnProperty('video_source')
    },
  },
  mounted() {
    this.$root.$on('ctaModal', (cta, isNew, video, hlsCode) => {
      this.cta = cta
      this.isNew = isNew
      this.video = video
      this.hlsCode = hlsCode
      this.open = true
      this.setOutsideBtnCode()
    })
  },
  beforeDestroy() {
    this.$root.$off('folderModal')
  },
  methods: {
    setOutsideBtnCode(target = 'standard') {
      if (this.isExternalSourceVideo) {
        this.outsideBtnCode = `<div id="${this.cta.divId}"></div>`
        this.targetItems = [this.targetItems[0]]
      } else if (
        this.cta.metadata.selectedButtonType === 'insideVideo' &&
        this.cta.metadata.appendWebsiteQueryParams
      ) {
        this.outsideBtnCode =
          `<script>if(!document.querySelector('script[src^="${this.scriptUrl}"]')){let s=document.createElement('script'); s.src='${this.scriptUrl}'; s.async=true; document.head.appendChild(s);}window.pandascripttag=window.pandascripttag || [];window.pandascripttag.push(function (){const p=new PandaPlayer('panda-${this.video.video_external_id}',{onReady(){p.setParentWindowUrl();}});})</scr` +
          'ipt>'
      } else if (this.cta.metadata.selectedButtonType === 'underVideo') {
        const targetCodes = {
          standard:
            `<script>if(!document.querySelector('script[src^="${
              this.scriptUrl
            }"]')){let s=document.createElement('script'); s.src='${
              this.scriptUrl
            }'; s.async=true; document.head.appendChild(s);}window.pandascripttag=window.pandascripttag || [];window.pandascripttag.push(function (){const p=new PandaPlayer('panda-${
              this.video.video_external_id
            }',{onReady(){p.loadButtonInTime({fetchApi: true})${
              this.cta.metadata.appendWebsiteQueryParams
                ? ';p.setParentWindowUrl();'
                : ''
            }}});})</scr` + `ipt><div id="${this.cta.divId}"></div>`,
          hls:
            `<script>document.addEventListener('readystatechange', ()=>{if (document.readyState !=='complete'){return;}let hlsLink='${
              this.hlsCode
            }'; let pullzone=hlsLink.split('b-')[1].split('.')[0]; let id=hlsLink.split('.com.br/')[1].split('/')[0]; if (!document.querySelector('script[src^="${
              this.scriptUrl
            }"]')){let s=document.createElement('script'); s.src='${
              this.scriptUrl
            }'; s.async=true; document.head.appendChild(s);}window.pandascripttag=window.pandascripttag || []; window.pandascripttag.push(function(){const p=new PandaPlayer('iframe[src*="'+pullzone+'"][src*="'+id+'"]',{onReady(){p.loadButtonInTime({fetchApi: true});${
              this.cta.metadata.appendWebsiteQueryParams
                ? ';p.setParentWindowUrl();'
                : ''
            }}});})})</scr` + `ipt><div id="${this.cta.divId}"></div>`,
        }
        this.outsideBtnCode = targetCodes[target]
      }
    },
    handleClose() {
      this.open = false
    },
    handleEnter() {
      this.edit ? this.handleEdit() : this.handleCreate()
    },
    handleShowLink(item) {
      this.isCopied = true
      navigator.clipboard.writeText(`${item}`)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },
  },
}
</script>

<style>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}

.embed-textarea-customHtml .v-text-field__slot {
  margin: 0 -10px 4px 0 !important;
}
</style>
